import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  hydraToken: string
  url: string
}

export const HydraCancelSubscription = ({ hydraToken, url }: Props) => {
  const request: SendRequestType = {
    method: 'DELETE',
    url,
    token: hydraToken,
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpTools.sendRequest(request)
}
